import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, markRaw, onMounted } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store";
import { Learning as LearningModel } from "@/models/learning";
import { DrawerMutations } from "@/stores/drawer.store";
import LearningForm from "./LearningForm.vue";
import LearningCalendar from "./LearningCalendar.vue";
import { CalendarData, CalendarDay } from "@/models/calendar";


export default /*#__PURE__*/_defineComponent({
  __name: 'Learnings',
  setup(__props) {

const store = useStore();
const learnings = computed<LearningModel[]>(() => store.state.learnings);
const calendar = computed<CalendarData>(() => store.state.calendar);

onMounted(() => {
  store.dispatch(Actions.GetCalendar);
  store.dispatch(Actions.GetLearnings);
});

const editLearning = (day: CalendarDay, learnings: LearningModel[]) => {
  if (!learnings?.length) {
    store.dispatch(Actions.NewLearning);
  }
  store.commit(DrawerMutations.OpenDrawer, {
    drawer: markRaw(LearningForm),
    data: {
      date: day.internal
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (calendar.value)
    ? (_openBlock(), _createBlock(LearningCalendar, {
        key: 0,
        calendar: calendar.value,
        learnings: learnings.value,
        onEdit: editLearning
      }, null, 8, ["calendar", "learnings"]))
    : _createCommentVNode("", true)
}
}

})